<mat-card [id]="activity.id" class="flex activity-card-block" (click)="onClickGo()">
  <!-- <div [innerHTML]="pictureDisplay"></div> -->
  <figure [id]="activity.id" class="activityPicDiv">
    <picture>
      @if (uniquePictures.length > 0) {
        @for (pic of uniquePictures; track pic._trackId || pic.id || pic.url || $index) {
          <img 
            mat-card-image 
            [id]="activity.id" 
            class="imageTransition" 
            [src]="pic.url" 
            [alt]="pic.description || activity.name"
            (error)="handleImageError($event, activity)"
            loading="lazy"
          >
        }
      } @else {
        <div class="imageTransition flex align-items-center justify-content-center" style="background-color: #f5f5f5; min-height: 200px; width: 100%;">
          <span style="color: #666; font-size: 14px;">Images coming soon</span>
        </div>
      }
    </picture>
  </figure>
  <div class="flex flexColumn spaceBetween dataSection">
    <div class="flex flex-column spaceBetween activityTopBar">
      <div class="flex spaceBetween">
        <div class="flex spaceBetween">
          @if (activity.topPick) {
            <button
              type="button"
              class="buttonStyle-primary buttonStyle-tag buttonStyle-tag-low"
            >Top Pick</button>
          }
          @if (activity.sellOut) {
            <button
              class="tags buttonStyle-primary buttonStyle-tag buttonStyle-tag-high"
              type="button"
            >Likely to sell out</button>
          }
        </div>
        <div>
          @if (!activity.favorite) {
            <img class="favoriteIcon favoriteIcon-not" src="../../../../assets/icons8-favorite-white.png" alt="">
          }
          @if (activity.favorite) {
            <img class="favoriteIcon" src="../../../../assets/icons8-favorite-filled.png" alt="">
          }
        </div>
      </div>
      <div class="flex flexColumn spaceBetween activityInfo activityInfo-mid">
        <div class="flex flexColumn">
          <mat-card-subtitle class="description">{{activity.name}}</mat-card-subtitle>
          <div class="flex">
            <span class="flex justify-content-center fw-bold me-1">{{activity.startDate | date:'MMM'}}</span>
            <span class="flex justify-content-center fw-bold">{{activity.startDate | date:'dd'}} | </span>
            <span class="flex justify-content-center fw-bold me-1 ms-1">{{activity.endDate | date:'MMM'}}</span>
            <span class="flex justify-content-center fw-bold">{{activity.endDate | date:'dd'}}</span>
          </div>

          <div>{{activity.duration}}</div>
          <!-- <ul class="amenitiesBar">
          <li *ngFor="let item of amenitiesBar">{{item}}</li>
        </ul> -->
        <!-- <mat-list>
        @for (item of amenitiesBar; track item) {
          <mat-list-item>
            <h3 matListItemTitle>{{item}}</h3>
          </mat-list-item>
        }
      </mat-list> -->
      <!-- <div class="flex flexColumn ">

    </div> -->
  </div>
  <div>
    <!-- <div class="flex spaceAround ratingSystem">
    <app-product-ratings [productRating]=rating></app-product-ratings>
    <span>{{rating}}</span>
    <span>{{reviews}}</span>
  </div> -->
  @if (!activity.discountedPrice || activity.discountedPrice === 0) {
    <div class="flex flexColumn description">
      <span>From {{activity.currencyType}} {{activity.pricePerPerson}}</span>
    </div>
  }
  @if (activity.discountedPrice && activity.discountedPrice > 0) {
    <div class="flex flexColumn description">
      <span class="strikThrough">From {{activity.currencyType}} {{activity.pricePerPerson}}</span>
      <div>
        <span class="discount">From {{activity.currencyType}} {{activity.pricePerPerson - (activity.pricePerPerson * (activity.discountedPrice/100))}}</span>
      </div>
    </div>
  }
</div>
</div>
<div class="flex spaceBetween">
  <mat-card-title class="mainActivityType">{{activity.mainActivityType}}</mat-card-title>
  <!-- <div class="flex spaceBetween ratingSystem">
  <app-product-ratings [productRating]=rating></app-product-ratings>
  <span>{{rating}}</span>
  <span>{{reviews}}</span>
</div> -->
</div>
</div>

<div class="flex flexColumn spaceBetween activityInfo activityInfo-bottom activityScheme">
  <mat-card-subtitle class="description">{{activity.name}}</mat-card-subtitle>
  <div class="flex flexColumn mt-2">
    <div class="flex">
      <div class="flex">
        <div class="flex flex-column justify-content-center">
          <span class="flex justify-content-center fw-bold">{{activity.startDate | date:'MMM'}}</span>
          <span class="flex justify-content-center fw-bold fs-3">{{activity.startDate | date:'dd'}}</span>
          <hr class="mt-1 mb-1" style="width: 10px; margin-left: 5px;">
          <span class="flex justify-content-center fw-bold">{{activity.endDate | date:'MMM'}}</span>
          <span class="flex justify-content-center fw-bold fs-3">{{activity.endDate | date:'dd'}}</span>
        </div>
      </div>
      <div class="ms-2 me-3 verticalLine"></div>
      <div class="flex flex-column">
        <div>{{activity.duration}}</div>
        <div class="flex">
          @if (!activity.discountedPrice || activity.discountedPrice === 0) {
            <div class="flex flexColumn description">
              <span>From {{activity.currencyType}} {{activity.pricePerPerson}}</span>
            </div>
          }
          @if (activity.discountedPrice && activity.discountedPrice > 0) {
            <div class="flex flexColumn description">
              <span class="strikThrough">From {{activity.currencyType}} {{activity.pricePerPerson}}</span>
              <div><span class="discount">From {{activity.currencyType}} {{activity.pricePerPerson - (activity.pricePerPerson * (activity.discountedPrice/100))}}</span></div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</mat-card>
